import Vue from 'vue';
import Vuetify from 'vuetify/lib';
/*import colors from 'vuetify/lib/util/colors'*/
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#000000', // #E53935
          secondary: '#B2DACD',
          accent: '#FE781E', // #3F51B5
          hzGrey:'#f7f7f7',
          hzPrimary:'#46deb6',
          hitziggradYellow: '#F7F6EF',
          hitziggradYellow2: '#fff6c1',
          hitziggradGreen: '#b2dacd',
          hitziggradOrange: '#fe781e',
          hitziggradOrange2: '#FEA76D',
          hitziggradSkin: '#ecc6a5',
          hitziggradPurple: '#763299',
          hitziggradGrey: '#969696',
          hitziggradGrey2: '#DDDDDD',
          hitziggradGrey3: '#E9E9E9'
          /*
          error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',*/
        },
      },
    },
  });
